import { put } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { newMessageEvent } from 'rdx/modules/messages/slice';
import { PayloadActionWithGenericPayload } from 'types/redux-types';

function* duplicateCytometerProfile({ payload }: PayloadActionWithGenericPayload) {
  const { action, params, onSuccess } = payload;

  const { success, data, error } = yield makeRequest.action( action, params );
  if (success && data) {
    if (onSuccess) {
      onSuccess(data?.data?.id);
    }
    yield put(newMessageEvent({ text: 'Cytometer Profile Duplicated' }));
  } else {
    yield* putErrorActions({ error });
  }
  return null;
}

export default duplicateCytometerProfile;
